import React from 'react';
import { IconProps, ToastContainer, cssTransition } from 'react-toastify';
import type { ToastContainerProps } from 'react-toastify';

import { Alert, CheckStroked, Close, Error, Info } from '../Icons';

const Toast = (props: ToastContainerProps) => {
  const transition = cssTransition({
    enter: 'bounce-enter',
    exit: 'fade-exit',
  });

  return (
    <ToastContainer
      icon={Icon}
      closeButton={({ closeToast }) => (
        <div className="flex" onClick={closeToast}>
          <Close className="fill-white self-center opacity-50 cursor-pointer" />
        </div>
      )}
      position="bottom-right"
      closeOnClick={false}
      hideProgressBar
      transition={transition}
      draggable={false}
      {...props}
    />
  );
};

const Icon: React.FC<IconProps> = ({ type }) => {
  switch (type) {
    case 'success':
      return (
        <CheckStroked className="fill-uta-success" width={18} height={18} />
      );
    case 'warning':
      return <Alert className="fill-uta-warning" width={18} height={18} />;
    case 'error':
      return <Error className="fill-uta-error" width={18} height={18} />;
    case 'info':
      return <Info className="fill-link-blue" width={18} height={18} />;
    case 'default':
      return null;
  }
};

export default Toast;
